(function($) {
  $(document).on('submit', '.naviti-form', function(e) {
    e.preventDefault();

    const $form = $(this);
    const $wrapper = $form.closest('.naviti-form-wrapper');
    const $submitButton = $form.find('.naviti-form-submit-button');
    const $successMessage = $form.find('.naviti-form-success');
    const $errorMessage = $form.find('.naviti-form-error');
    const formId = $form.data('form-id');

    $successMessage.addClass('nvi:hidden');
    $errorMessage.addClass('nvi:hidden');
    $submitButton.prop('disabled', true).text('Submitting...');

    const formData = {};
    $form.find('input, textarea, select').each(function() {
      const $field = $(this);
      const name = $field.attr('name');
      const value = $field.val();

      if (name) {
        formData[name] = value;
      }
    });

    $.ajax({
      url: NAVITI.ajaxUrl,
      type: 'POST',
      data: {
        action: 'naviti_submit_form',
        nonce: NAVITI.nonce,
        form_id: formId,
        form_data: formData
      },
      success: function(response) {
        if (response.success) {
          $form[0].reset();
          $successMessage.html(response.data.message).removeClass('nvi:hidden');
          $successMessage.after($(response.data.tracking_code));

          setTimeout(function() {
            $successMessage.addClass('nvi:hidden');
          }, 5000);
        } else {
          $errorMessage.html(response.data.message).removeClass('nvi:hidden');
        }
      },
      error: function() {
        $errorMessage.html('An error occurred. Please try again.').removeClass('nvi:hidden');
      },
      complete: function() {
        $submitButton.prop('disabled', false).text($submitButton.data('original-text') || 'Submit');
      }
    });
  });

  $(document).ready(function() {
    $('.naviti-form-submit-button').each(function() {
      $(this).data('original-text', $(this).text());
    });
  });
})(jQuery);
